/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
// import auth from "@/auth/authService";
import store from "./store/store";
import {
  clearPopStateNavigationFlag,
  hardReloadPromotionPage,
  setupPromotionReloadHandlers,
  shouldHardReloadPromotionOnBack,
} from "@/utils/promotionReload";
// import firebase from 'firebase/app'
// import 'firebase/auth'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/button",
          name: "Buttons",
          component: () => import("../src/views/ui-elements/data-list/list-view/DataListListView.vue"),
          meta: {
            rule: "admin",
            authRequired: false
          }
        },


        {
          path: "/",
          meta: {
            rule: "unknown",
            authRequired: true
          },
          beforeEnter(to, from, next) {
            if (localStorage.getItem("role") == "admin") {
              next("/dashboard");
            } else if (localStorage.getItem("role") == "delivery") {
              next("/make-booking");
            }
          }
          //  redirect: '/dashboard/analytics'
        },
        {
          path: "/kanwal",
          name: "UserList",
          component: () => import("./views/ui-elements/table/Table.vue"),
          meta: {
            rule: "admin",
            authRequired: false
          }
        },
        {
          path: "/venue/add",
          name: "add-venue",
          component: () => import("./views/venues/AddVenue"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: () => import("./views/DashboardAnalytics"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/venues",
          name: "list-venues",
          component: () => import("./views/venues/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/venue/view/:id",
          name: "show-venue",
          component: () => import("./views/venues/View"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/venue/edit/:id",
          name: "edit-venue",
          component: () => import("./views/venues/AddVenue"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/bookings",
          name: "list-bookings",
          component: () => import("./views/taxipoint/bookings/newIndex"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/statistics",
          name: "list-statistics",
          component: () => import("./views/taxipoint/statistics/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/analytics",
          name: "analytics",
          component: () => import("./views/taxipoint/analytics/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/qrbooker-analytics",
          name: "qrbooker-analytics",
          component: () => import("./views/taxipoint/qrbooker-analytics/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/journey-analytics",
          name: "journey-analytics",
          component: () => import("./views/taxipoint/journey-analytics/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/kiosk-analytics",
          name: "kiosk-analytics",
          component: () => import("./views/taxipoint/kiosk-analytics/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/companyprofile",
          name: "company-profile",
          component: () => import("./views/taxipoint/companyprofile/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/companies",
          name: "companies",
          component: () => import("./views/taxipoint/companies/Index"),
          meta: {
            rule: "admin",
            authRequired: true,
            visible: false
          }
        },
        {
          path: "/payments",
          name: "payments",
          component: () => import("./views/taxipoint/payments/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },

        {
          path: "/services/SMSPAY",
          name: "services",
          component: () => import("./views/taxipoint/services/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        {
          path: "/services/pay-by-link",
          name: "paybylinkservices",
          component: () => import("./views/taxipoint/services/pay-by-link"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },
        // {
        //   path: "/ui-elements/table",
        //   name: "Table",
        //   component: () => import("./views/ui-elements/table/Table.vue"),
        //   meta: {
        //     rule: "admin",
        //     authRequired: true
        //   }
        // },
        {
          path: "/contactUs",
          name: "contactUs",
          component: () => import("./views/taxipoint/contactUs/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },

        {
          path: "/manage-users",
          name: "manage-users",
          component: () => import("./views/taxipoint/users/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },

        {
          path: "/venue-qr-booker",
          name: "qr-booker",
          component: () => import("./views/taxipoint/QRbooker/Index"),
          meta: {
            rule: "admin",
            authRequired: true
          }
        },

        // =============================================================================
        // Application Routes
        // =============================================================================
        {
          path: "/apps/user/user-view/:userId",
          name: "app-user-view",
          component: () => import("@/views/apps/user/UserView.vue"),
          meta: {
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "User" },
              { title: "View", active: true }
            ],
            pageTitle: "User View",
            rule: "admin"
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        // {
        //   path: '/callback',
        //   name: 'auth-callback',
        //   component: () => import('@/views/Callback.vue'),
        //   meta: {
        //     rule: 'admin'
        //   }
        // },
        // {
        //     path: '/pages/login',
        //     name: 'page-login',
        //     component: () => import('@/views/pages/login/Login.vue'),
        //     meta: {
        //         rule: 'admin'
        //     }
        // },
        // {
        //     path: '/pages/register',
        //     name: 'page-register',
        //     component: () => import('@/views/pages/register/Register.vue'),
        //     meta: {
        //         rule: 'admin'
        //     }
        // },
        // {
        //     path: '/pages/forgot-password',
        //     name: 'page-forgot-password',
        //     component: () => import('@/views/pages/ForgotPassword.vue'),
        //     meta: {
        //         rule: 'admin'
        //     }
        // },
        // {
        //     path: '/pages/reset-password',
        //     name: 'page-reset-password',
        //     component: () => import('@/views/pages/ResetPassword.vue'),
        //     meta: {
        //         rule: 'admin'
        //     }
        // },
        {
          path: "/pages/lock-screen",
          name: "page-lock-screen",
          component: () => import("@/views/pages/LockScreen.vue"),
          meta: {
            rule: "admin"
          }
        },
        {
          path: "/pages/comingsoon",
          name: "page-coming-soon",
          component: () => import("@/views/pages/ComingSoon.vue"),
          meta: {
            rule: "admin"
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "admin"
          }
        },
        {
          path: "/pages/error-500",
          name: "page-error-500",
          component: () => import("@/views/pages/Error500.vue"),
          meta: {
            rule: "admin"
          }
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "admin"
          }
        }
        // {
        //   path: '/pages/maintenance',
        //   name: 'page-maintenance',
        //   component: () => import('@/views/pages/Maintenance.vue'),
        //   meta: {
        //     rule: 'admin'
        //   }
        // },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [

        {
          path: "/charts-and-maps/charts/apex-charts",
          name: "Apex Charts",
          component: () => import("./views/charts-and-maps/charts/apex-charts/ApexCharts.vue"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        }, {
          path: "/pages/profile",
          name: "Profile",
          component: () => import("./views/components/extra-components/datepicker/Datepicker.vue"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        }, {
          path: "/charts-and-maps/charts/echarts",
          name: "Apex Charts",
          component: () => import("./views/charts-and-maps/charts/echarts/Echarts.vue"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        },
        {
          path: "/pay/:number",
          name: "Payment",
          component: () => import("./views/taxipoint/judo"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        },

        {
          path: "/p/:sysdomain/:bid",
          name: "SmsPayment",
          component: () => import("./views/taxipoint/promotionNUDG"),
          meta: {
            rule: "unknown",
            authRequired: false,
            loadingImage: 'NudgPay.png',
            favicon: 'nudgpay-favicon.ico'
          }
        },
        {
          path: "/p/:sysdomain/:bid/live-track",
          name: "LiveTracking",
          component: () => import("./views/taxipoint/LiveTracking"),
          meta: {
            rule: "unknown",
            authRequired: false,
            favicon: 'nudgtrack-favicon.ico'
          },
        },

        {
          path: "/book-by-qr/:venue_id",
          name: "BookByQr",
          component: () => import("./views/taxipoint/BookByQr"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        },
        {
          path: "/p/:sysdomain/:booking/redirect/:response",
          name: "SmsPaymentRedirect",
          component: () => import("./views/taxipoint/SmspayRedirect"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        },
        {
          path: "/status/:order",
          name: "OrderStatus",
          component: () => import("./views/taxipoint/OrderStatus"),
          meta: {
            rule: "unknown",
            authRequired: false
          }
        },
        {
          path: "/make-booking",
          name: "make-booking",
          component: () => import("./views/customer/UserDashboard.vue"),
          meta: {
            rule: "unknown",
            authRequired: true,
            no_scroll: true
          }
        },
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/Auth/Login.vue"),
          meta: {
            rule: "unknown"
          }
        },
        {
          path: "/register",
          name: "page-register",
          component: () => import("@/views/Auth/Register.vue"),
          meta: {
            rule: "unknown"
          }
        },
        {
          path: "/forgot-password",
          name: "page-forgot-password",
          component: () => import("@/views/Auth/ForgotPassword.vue"),
          meta: {
            rule: "unknown"
          }
        },
        {
          path: "/reset-password/:hash/:email",
          name: "page-reset-password",
          component: () => import("@/views/Auth/ResetPassword.vue"),
          meta: {
            rule: "unknown"
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/nudg/:bid",
      name: "Nudg ",
      component: () => import("./views/taxipoint/promotionNUDG"),
      meta: {
        rule: "unknown",
        authRequired: false
      }
    },
  ]
});

setupPromotionReloadHandlers();

router.afterEach((to, from) => {
  // Remove initial
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  if (shouldHardReloadPromotionOnBack(to, from)) {
    clearPopStateNavigationFlag();
    hardReloadPromotionPage();
    return;
  }
  clearPopStateNavigationFlag();

  if (to.meta.authRequired) {
    if (localStorage.getItem("role") == "unknown") {
      next("/login");
    } else {
      // Block QR booker route unless user has venue_qr_booker feature
      if (to.path === "/venue-qr-booker" && !store.getters.hasFeature("venue_qr_booker")) {
        return next("/pages/not-authorized");
      }

      let per = store.state.AppActiveUser.permissions;
      if (localStorage.getItem("role") == "admin") {
        if (Object.keys(per).length === 0 && per.constructor === Object)
          return next();
        else if (per.find(p => to.path.includes(p.path) && p.selected)) return next();
        else return next("/pages/not-authorized");
      }
    }
  }
  if (to.meta.loadingImage) {

    const loadingImg = document.getElementById('loadingImg');

    if (loadingImg) {
      const imgName = to.meta.loadingImage || 'logo.png'; // fallback to default logo
      loadingImg.src = `${process.env.BASE_URL}${imgName}`;

    }
  }
  if (to.meta.favicon) {
    const favicon = document.getElementById('favicon');
    const iconName = to.meta.favicon || 'logo.ico';

    if (favicon) {
      favicon.href = `${process.env.BASE_URL}${iconName}`;
    }
  }
  return next();
});

export default router;
